import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChevronRight } from 'lucide-react';

export default function KPIMetricCard({ icon: Icon, title, description, value, onClick, testId, iconBgClass = 'bg-slate-100', iconClass = 'text-slate-600' }) {
  return (
    <Card 
      className={`${onClick ? 'cursor-pointer hover:border-slate-400 transition-colors' : ''}`}
      onClick={onClick}
      data-testid={testId}
    >
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        <div className={`p-2 rounded-lg ${iconBgClass}`}>
          <Icon className={`h-5 w-5 ${iconClass}`} />
        </div>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{value}</div>
        <p className="text-xs text-muted-foreground flex items-center gap-1">
          {description}
          {onClick && <ChevronRight className="h-3 w-3" />}
        </p>
      </CardContent>
    </Card>
  );
}
